import { useParams } from "react-router-dom";
import { useGetSubscriptionMoneyRecieptById } from "../../../API/subscriptionPayment.api";
import SubscriptionInvoicePage from "./SubscriptionInvoicePage";
import LoaderLayout from "../../../components/Layout/LoaderLayout";
import { Button } from "react-bootstrap";

const SubscriptionMoneyReciept = () => {
	const { id } = useParams();
	const { data, isLoading } = useGetSubscriptionMoneyRecieptById(id);
	console.log("data", data);
	return (
		<LoaderLayout isPending={isLoading}>
			<div className="print-hidden text-end">
				<Button onClick={() => window.print()}>Print</Button>
			</div>

			<SubscriptionInvoicePage isMoneyReciept={true} moneyRecieptData={data} />
		</LoaderLayout>
	);
};

export default SubscriptionMoneyReciept;
